import type { HttpGet } from '@/shared/infra/http'
import type { EligibleMember, ListEligibleMembers } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

type EligibleMemberDto = {
  userId: string
  name?: string | null
  registered?: boolean | null
}

type ListEligibleMembersResponseDto = {
  members?: EligibleMemberDto[] | null
}

function toEligibleMember(dto: EligibleMemberDto): EligibleMember {
  return {
    userId: dto.userId,
    name: dto.name ?? 'Member',
    registered: Boolean(dto.registered),
  }
}

export class EdgeListEligibleMembersRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListEligibleMembers = async (params) => {
    const query = `?orgId=${encodeURIComponent(params.orgId)}&orgType=${params.orgType}`
    try {
      const data = await this.http.get<ListEligibleMembersResponseDto>({
        url: `/connect/channels/eligible-members${query}`,
      })
      return {
        members: (data?.members ?? []).map(toEligibleMember),
      }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
